import { combineReducers } from 'redux';
import Users from '../views/Users/redux/UsersReducers';
import Roles from '../views/Roles/redux/RolesReducers';
import About from '../views/About/redux/AboutReducers';
import Celebrities from '../views/Celebrities/redux/CelebritiesReducers';
import Collections from '../views/Collections/redux/CollectionsReducers';
import Categories from '../views/Categories/redux/CategoriesReducers';
import PressKits from '../views/PressKits/redux/PressKitsReducers';
import Videos from '../views/Videos/redux/VideosReducers';

export default combineReducers({
  Users,
  Roles,
  About,
  Celebrities,
  Collections,
  Categories,
  PressKits,
  Videos
});



// WEBPACK FOOTER //
// ./src/store/reducers.js